var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9.5 2.99h4a.5.5 0 1 1 0 1h-1v10.758c0 .69-.562 1.252-1.252 1.252H2.752c-.69 0-1.252-.562-1.252-1.252V3.99h-1a.5.5 0 0 1 0-1h4V2.5C4.5 1.121 5.622 0 7 0c1.379 0 2.5 1.121 2.5 2.5v.49zm-1 0V2.5C8.5 1.673 7.827 1 7 1s-1.5.673-1.5 1.5v.49h3zm-6 1v10.758c0 .139.113.252.252.252h8.496a.252.252 0 0 0 .252-.252V3.99h-9zm2 9a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5zm5 0a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5zm-2.5.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 1 0v7a.5.5 0 0 1-.5.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8A8E96",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h16v16H-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a7780c52951ae1af5a82f3b604fbd512.svg";
export { ForwardRef as ReactComponent };